/**
 * Country configuration for Algeria/Tunisia integration
 * Determines currency and locale based on user's country
 */

const COUNTRY_CONFIG = {
  DZ: {
    currency: { code: "DZD", symbol: "DA" },
    locale: "fr-DZ",
  },
  TN: {
    currency: { code: "TND", symbol: "DT" },
    locale: "fr-TN",
  },
};

/**
 * Get the current country from storage or environment
 * Priority: localStorage > sessionStorage > env var > default (TN)
 */
export const getCountry = () => {
  // Try localStorage first
  const storedCountry = localStorage.getItem("country");
  if (storedCountry && (storedCountry === "DZ" || storedCountry === "TN")) {
    return storedCountry;
  }

  // Try sessionStorage
  const sessionCountry = sessionStorage.getItem("country");
  if (sessionCountry && (sessionCountry === "DZ" || sessionCountry === "TN")) {
    return sessionCountry;
  }

  // Try build-time env var (for Create React App, use REACT_APP_ prefix)
  const envCountry = process.env.REACT_APP_COUNTRY;
  if (envCountry && (envCountry === "DZ" || envCountry === "TN")) {
    return envCountry;
  }

  // Default to Tunisia
  return "TN";
};

/**
 * Get currency configuration for current country
 */
export const getCurrency = () => {
  const country = getCountry();
  return COUNTRY_CONFIG[country]?.currency || COUNTRY_CONFIG.TN.currency;
};

/**
 * Get locale for current country
 */
export const getLocale = () => {
  const country = getCountry();
  return COUNTRY_CONFIG[country]?.locale || COUNTRY_CONFIG.TN.locale;
};

export default COUNTRY_CONFIG;

